import { Box, LoadingOverlay } from '@mantine/core';
import { getInvoiceFormValues, InvoiceForm } from 'modules/Invoices/InvoiceForm';
import type { RouteComponentProps } from 'react-router';
import { useHistory } from 'react-router';
import { isDefined } from 'remeda';
import { useCreateInvoice } from 'shared/hooks/use-create-invoice';
import { useLoadInvoice } from 'shared/hooks/use-load-invoice';
import { useUpdateInvoice } from 'shared/hooks/use-update-invoice';
import { isDraft } from 'shared/utils/invoice-status';

export default function ManageInvoice({ match: { params } }: RouteComponentProps<{ id?: string }>) {
  const history = useHistory();

  const { createInvoice } = useCreateInvoice({
    onSuccess: response => {
      const newInvoice = response.data.data;
      history.push(newInvoice ? `/invoices/draft/${newInvoice.id}` : '/invoices');
    },
  });

  const { updateInvoice } = useUpdateInvoice({
    onSuccess: (response, variables) => {
      if (isDraft(response.data.data.attributes)) {
        history.push(`/invoices/draft/${variables.id}`);
      }
    },
  });

  const invoiceId = params.id ? Number(params.id) : undefined;
  const { invoice } = useLoadInvoice(invoiceId);

  const isEditMode = isDefined(invoiceId);

  if (isEditMode && !isDefined(invoice)) {
    return (
      <Box h="100%" pos="relative">
        <LoadingOverlay visible />
      </Box>
    );
  }

  if (isEditMode && isDefined(invoice)) {
    return (
      <InvoiceForm
        initialValues={getInvoiceFormValues(invoice)}
        invoice={invoice}
        submit={data => updateInvoice({ id: invoice.id, data })}
      />
    );
  }

  return <InvoiceForm submit={data => createInvoice({ data })} />;
}
